import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var SliderContainerWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.tiny;
});
var Root = SliderContainerWrapper;

export { Root as default };
//# sourceMappingURL=SliderContainer.styles.js.map
